import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import Referrals from './Referrals';
import Projects from './Projects';
import { API_BASE, Functionality } from '../context/Functionality';

export default function AccountPortal() {
  const { token, user, logout } = useContext(Functionality);
  const { id } = useParams();
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setResult(null); setError('');
    axios.get(`${API_BASE}/api/portals/${id || 'me'}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => { if (active) setResult(data); })
      .catch(err => { if (active) setError(err.response?.data?.errMsg || 'Unable to load the portal. Please try again.'); });
    return () => { active = false; };
  }, [token, id]);
  return <main className="max-w-5xl mx-auto min-h-screen px-6 py-12">
    <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
      <h1 className="text-3xl font-bold text-[#002D74]">{id && id !== user._id ? 'Account portal' : 'Your portal'}</h1>
      <button onClick={logout} className="underline">Sign out</button>
    </div>
    {user.isEmployee && <nav className="flex gap-6 mb-8"><Link className="underline" to="/business-list">Employee portal</Link><Link className="underline" to="/referrals">Referral queue</Link><Link className="underline" to="/account-portals">Client projects</Link></nav>}
    {error && <p role="alert">{error}</p>}
    {!error && !result && <p role="status">Loading…</p>}
    {result && <>
      <section className="rounded-2xl border bg-gray-50 p-6 mb-8">
        <h2 className="text-xl font-semibold">{result.owner.firstName} {result.owner.lastName}</h2>
        <p className="text-gray-600 mt-2">{result.owner.email}</p>
      </section>
      <Projects key={result.id} ownerId={result.id} />
      <Referrals key={`referrals-${result.id}`} ownerId={result.id} />
    </>}
  </main>;
}
